export default function FullImageSlide({ image, className = '' }) {
  return (
    <div className={`slide gallery-slide full-image-slide ${className}`}>
      <img src={image} />
    </div>
  )
}
